import { render, staticRenderFns } from "./terminos_condiciones.vue?vue&type=template&id=032e4a2b"
import script from "./terminos_condiciones.vue?vue&type=script&lang=js"
export * from "./terminos_condiciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports